module.exports = __webpack_public_path__ + "img/biofreeze_cold_therapy_pain_relief_gel.17678cbd.jpg";